import React from "react";
import { map } from "lodash";
import { Lazy } from "@/components/Lazy";
import { Link } from "../Link";
import { checkValidURL } from "@/utils/formHelper";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { PreviewLayout } from ".";
import { Typography } from "../Typography";
import { IconList } from "../IconList";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";

export default function PreviewLinks(props: QRProps<"links">) {
  const qrEditorContextData = React.useContext<QREditorContextProps<"links">>(QREditorContext);
  const data = props?.data || qrEditorContextData?.qrData.data;

  const isInitPreview = props?.initPreview;
  const { title, description, links, logoUrl, socialNetworks, themeColor, socialLogos } = data;

  return (
    <PreviewLayout
      page="links"
      dataQA="preview-links-container"
      backgroundColor={themeColor?.backgroundColor}
      includeBrowser
      isInitPreview={isInitPreview}>
      <div className="qr-content">
        {logoUrl &&
          (isInitPreview ? (
            <Lazy placeholderClass="skeleton-placeholder__links__image">
              <img
                src={logoUrl}
                alt="link preview"
              />
            </Lazy>
          ) : (
            <div className="links-logo--container">
              <Lazy placeholderClass="links-logo">
                <img
                  src={optimizeCloudinaryImage({
                    url: logoUrl,
                    transformations: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
                  })}
                  className="links-logo"
                />
              </Lazy>
            </div>
          ))}
        {title && (
          <div className="links-title">
            <Typography
              Tag="p"
              classname="u-semibold u-spacing-4">
              {title}
            </Typography>
          </div>
        )}
        {description && (
          <div className="links-subtitle">
            <Typography
              Tag="p"
              classname="u-spacing-4">
              {description}
            </Typography>
          </div>
        )}
        {links?.length > 0 && (
          <div className="u-spacing-5 preview-links-container">
            {map(links, (link, idx) => (
              <Link
                externalLink
                key={idx}
                className={`button u-spacing-3 link-a-tag ${link.linkImageUrl ? "with-img" : ""}`}
                href={checkValidURL(link.linkUrl) || ""}
                style={{
                  backgroundColor: themeColor?.buttonColor,
                }}
                prefetch={false}>
                {link.linkImageUrl && (
                  <Lazy placeholderClass="link-item-img">
                    <img
                      className="link-item-img"
                      src={optimizeCloudinaryImage({
                        url: link.linkImageUrl,
                        transformations: ["h_96,w_152,q_auto,f_auto"],
                      })}
                    />
                  </Lazy>
                )}
                <div className="link-item-label">
                  <span
                    data-testid="button-label"
                    className="button__text-label">
                    {link.linkText}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}

        {isInitPreview && (
          <div className="initPreview-logos">
            {socialLogos?.map((socialLogo) => (
              <Lazy
                key={socialLogo}
                placeholderClass="skeleton-placeholder__links__logo">
                <img
                  key={socialLogo}
                  src={socialLogo}
                  alt="pdf menu preview"
                />
              </Lazy>
            ))}
          </div>
        )}
        <div className="links-socialNetworks">
          <IconList
            center
            items={socialNetworks}
          />
        </div>
      </div>
    </PreviewLayout>
  );
}
